export default {
    config: {
        defaultWidth: 240,
        align: 'left'
    },
    default: {
        label: 'Players'
    },
    lang: {
        name: 'Play Players',
        category: ['User', 'Plays'],
        description: 'The players logged for a play.',
        views: ['list', 'sheet'],
        contexts: ['plays']
    },
    filters: ['played.with']
}